import React from 'react';
import PageHeader from '../components/layout/PageHeader';
const TermsOfUse = () => {
  return <div className="min-h-screen bg-white" data-id="element-5868">
      <PageHeader title="Terms of Use" description="Please read these terms carefully before using our website." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Terms of Use',
      path: '/terms-of-use'
    }]} data-id="element-5869" />
      <div className="container mx-auto px-4 py-12" data-id="element-5870">
        <div className="max-w-4xl mx-auto bg-white p-6 md:p-8 rounded-lg shadow-md" data-id="element-5871">
          <div className="prose prose-blue max-w-none" data-id="element-5872">
            <h2 data-id="element-5873">Terms of Use</h2>
            <p data-id="element-5874">
              <strong data-id="element-5875">Last Updated:</strong> January 1, 2025
            </p>
            <p data-id="element-5876">
              Welcome to the Isonyin Grammar School website. By accessing or
              using our website, you agree to be bound by these Terms of Use and
              our Privacy Policy. If you do not agree to these terms, please do
              not use our website.
            </p>
            <h3 data-id="element-5877">1. Acceptance of Terms</h3>
            <p data-id="element-5878">
              These Terms of Use constitute a legally binding agreement between
              you and Isonyin Grammar School governing your access to and use of
              the website. By using our website, you acknowledge that you have
              read, understood, and agree to be bound by these terms.
            </p>
            <h3 data-id="element-5879">2. Changes to Terms</h3>
            <p data-id="element-5880">
              We reserve the right to modify these Terms of Use at any time. Any
              changes will be effective immediately upon posting on the website.
              Your continued use of the website after any such changes
              constitutes your acceptance of the new Terms of Use.
            </p>
            <h3 data-id="element-5881">3. Intellectual Property Rights</h3>
            <p data-id="element-5882">
              All content on this website, including but not limited to text,
              graphics, logos, images, audio clips, digital downloads, data
              compilations, and software, is the property of Isonyin Grammar
              School or its content suppliers and is protected by Nigerian and
              international copyright laws.
            </p>
            <p data-id="element-5883">
              The compilation of all content on this website is the exclusive
              property of Isonyin Grammar School and is protected by Nigerian
              and international copyright laws. All trademarks, service marks,
              and trade names used on this website are the property of their
              respective owners.
            </p>
            <h3 data-id="element-5884">4. Permitted Use</h3>
            <p data-id="element-5885">
              You are granted a limited, non-exclusive, non-transferable, and
              revocable license to access and use the website for personal,
              non-commercial purposes. You may not:
            </p>
            <ul data-id="element-5886">
              <li data-id="element-5887">
                Use the website for any illegal purpose or in violation of any
                local, state, national, or international law
              </li>
              <li data-id="element-5888">
                Modify, adapt, translate, reverse engineer, decompile, or
                disassemble any portion of the website
              </li>
              <li data-id="element-5889">
                Remove any copyright, trademark, or other proprietary notices
                from the website
              </li>
              <li data-id="element-5890">
                Frame or mirror any part of the website without our express
                written consent
              </li>
              <li data-id="element-5891">
                Use any robot, spider, site search/retrieval application, or
                other automated device to retrieve, index, "scrape," "data
                mine," or otherwise gather content from the website
              </li>
              <li data-id="element-5892">
                Reproduce, duplicate, copy, sell, resell, or exploit for any
                commercial purpose any portion of the website
              </li>
            </ul>
            <h3 data-id="element-5893">5. User Conduct</h3>
            <p data-id="element-5894">By using this website, you agree not to:</p>
            <ul data-id="element-5895">
              <li data-id="element-5896">
                Post, upload, or transmit any content that is unlawful, harmful,
                threatening, abusive, harassing, defamatory, vulgar, obscene,
                invasive of another's privacy, or otherwise objectionable
              </li>
              <li data-id="element-5897">
                Impersonate any person or entity or falsely state or otherwise
                misrepresent your affiliation with a person or entity
              </li>
              <li data-id="element-5898">
                Interfere with or disrupt the website or servers or networks
                connected to the website
              </li>
              <li data-id="element-5899">
                Attempt to gain unauthorized access to any portion of the
                website or any other systems or networks connected to the
                website
              </li>
              <li data-id="element-5900">
                Use the website to send unsolicited or unauthorized advertising,
                promotional materials, junk mail, spam, or any other form of
                solicitation
              </li>
            </ul>
            <h3 data-id="element-5901">6. Disclaimer of Warranties</h3>
            <p data-id="element-5902">
              THE WEBSITE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT ANY
              WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT
              NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS
              FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
            </p>
            <p data-id="element-5903">
              Isonyin Grammar School does not warrant that the website will be
              uninterrupted or error-free, that defects will be corrected, or
              that the website or the servers that make it available are free of
              viruses or other harmful components.
            </p>
            <h3 data-id="element-5904">7. Limitation of Liability</h3>
            <p data-id="element-5905">
              IN NO EVENT SHALL ISONYIN GRAMMAR SCHOOL BE LIABLE FOR ANY DIRECT,
              INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES
              WHATSOEVER RESULTING FROM ANY (I) ERRORS, MISTAKES, OR
              INACCURACIES OF CONTENT, (II) PERSONAL INJURY OR PROPERTY DAMAGE
              OF ANY NATURE WHATSOEVER RESULTING FROM YOUR ACCESS TO AND USE OF
              OUR WEBSITE, (III) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE
              SERVERS AND/OR ANY PERSONAL INFORMATION STORED THEREIN, (IV) ANY
              INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM OUR WEBSITE,
              (V) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE
              TRANSMITTED TO OR THROUGH OUR WEBSITE BY ANY THIRD PARTY, AND/OR
              (VI) ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS OR
              DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT
              POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE
              WEBSITE.
            </p>
            <h3 data-id="element-5906">8. Indemnification</h3>
            <p data-id="element-5907">
              You agree to defend, indemnify, and hold harmless Isonyin Grammar
              School, its officers, directors, employees, and agents, from and
              against any and all claims, damages, obligations, losses,
              liabilities, costs or debt, and expenses (including but not
              limited to attorney's fees) arising from: (i) your use of and
              access to the website; (ii) your violation of any term of these
              Terms of Use; (iii) your violation of any third-party right,
              including without limitation any copyright, property, or privacy
              right; or (iv) any claim that your content caused damage to a
              third party.
            </p>
            <h3 data-id="element-5908">9. External Links</h3>
            <p data-id="element-5909">
              Our website may contain links to third-party websites that are not
              owned or controlled by Isonyin Grammar School. We have no control
              over, and assume no responsibility for, the content, privacy
              policies, or practices of any third-party websites. By using this
              website, you expressly relieve Isonyin Grammar School from any and
              all liability arising from your use of any third-party website.
            </p>
            <h3 data-id="element-5910">10. Termination</h3>
            <p data-id="element-5911">
              We reserve the right to terminate or restrict your access to our
              website, without notice and in our sole discretion, for any or no
              reason whatsoever.
            </p>
            <h3 data-id="element-5912">11. Governing Law</h3>
            <p data-id="element-5913">
              These Terms of Use shall be governed by and construed in
              accordance with the laws of the Federal Republic of Nigeria,
              without regard to its conflict of law principles. Any dispute
              arising under or relating in any way to these Terms of Use shall
              be resolved exclusively by the courts located in Ogun State,
              Nigeria.
            </p>
            <h3 data-id="element-5914">12. Severability</h3>
            <p data-id="element-5915">
              If any provision of these Terms of Use is found to be invalid or
              unenforceable, the remaining provisions shall remain in full force
              and effect.
            </p>
            <h3 data-id="element-5916">13. Entire Agreement</h3>
            <p data-id="element-5917">
              These Terms of Use constitute the entire agreement between you and
              Isonyin Grammar School regarding the use of the website,
              superseding any prior agreements between you and Isonyin Grammar
              School relating to your use of the website.
            </p>
            <h3 data-id="element-5918">14. Contact Information</h3>
            <p data-id="element-5919">
              If you have any questions about these Terms of Use, please contact
              us at:
            </p>
            <p data-id="element-5920">
              Isonyin Grammar School
              <br data-id="element-5921" />
              Isonyin Road, Ijebu-Ode
              <br data-id="element-5922" />
              Ogun State, Nigeria
              <br data-id="element-5923" />
              Email:{' '}
              <a href="mailto:info@isonyingrammarschool.ng" data-id="element-5924">
                info@isonyingrammarschool.ng
              </a>
              <br data-id="element-5925" />
              Phone: +234 905 517 2703
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default TermsOfUse;